var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.title)?_c('div',{staticClass:"ml-card-header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"ml-card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }